
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  name: "CrossInfoPanel",
})
export default class CrossRegionMenu extends Vue {
  private width = 387;
  private height = 128;
  @Prop({ type: Array }) readonly center!: Array<number>;
  @Prop({ type: String }) readonly videoUrl!: string;
  @Prop({ type: String }) readonly id!: string;
  @Prop({ type: String }) readonly lineDir!: string;
  @Prop({ type: Array }) readonly devicePosition!: Array<number>;

  get left() {
    return this.center[0] - this.width / 2;
  }

  get top() {
    return this.center[1] - this.height / 2;
  }
}
